import { createFileRoute } from '@tanstack/react-router'
import { SelectAssigneeRouteComponent } from '../../../../../../../../../../../containers/tasks/create-task/select-assignee-route-component'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/'
)({
  component: SelectAssigneeRouteComponent
})
